import { render, staticRenderFns } from "./PartnerScorecard.vue?vue&type=template&id=2ffc49b3"
import script from "./PartnerScorecard.vue?vue&type=script&lang=js"
export * from "./PartnerScorecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports